import {LocalizationStrings} from "../../i18n/i18n-model";
import {formatDateFromIso, formatDateTime} from "../date-time-utils";
import {FileOptions, SelectionOptions} from "./form-field.component";

export interface FormFieldConfig<T> {
  readonly type: FormFieldType;
  readonly property: keyof T;
  readonly label: keyof LocalizationStrings;
  readonly invalidLabel?: keyof LocalizationStrings;
  readonly infoLabel?: keyof LocalizationStrings;
  required?: boolean;
  selectionOptions?: SelectionOptions<any>;
  readonly fileOptions?: FileOptions;
  readonly model: T;
  readonly propertyChangeListener?: PropertyChangeListener<T>;
  readonly isValid: () => boolean | undefined;
  readonly alignLabelRight?: boolean;
  readonly verticalLayout?: boolean;
  readonly readOnly?: boolean;
  readonly filledByNurseOnly?: boolean;
  readonly autoexpand?: boolean;
  readonly autocomplete?: string;
  readonly disableFutureDates?: boolean;
  readonly firstPickYear?: boolean;
}

export const ALL_FORM_FIELD_TYPES = [
 "text",
 "number",
 "file",
 "dropdown",
 "radio",
 "header",
 "textarea",
 "password",
 "wrapper",
 "localdatetime",
 "localdate",
 "checkbox",
 "positiveWholeNumber",
] as const;
type FormFieldTypeTuple = typeof ALL_FORM_FIELD_TYPES;
export type FormFieldType = FormFieldTypeTuple[number]; // union type

export interface PropertyChangeListener<T> {
  handlePropertyChange(property: keyof T, newValue: any): void;
}

export function translateFormValue<T>(formFieldConfig: FormFieldConfig<any>,
  formValue: any,
  translate: (key: keyof LocalizationStrings) => string
): string {
  if (formValue === undefined || formValue === null) {
    return "";
  }

  if (formFieldConfig.type === "localdatetime") {
    return formatDateTime(formValue);
  }

  if (formFieldConfig.type === "localdate") {
    return formatDateFromIso(formValue);
  }

  if (formFieldConfig.type === "dropdown" || formFieldConfig.type === "radio") {
    const option = formFieldConfig.selectionOptions!.items.find((item) => item.value === formValue);

    return !!option ? translate(option.text as keyof LocalizationStrings) : "";
  }


  return formValue.toString();
}
